import { Map } from 'immutable';
import {
  types as buildsTypes,
} from '@saucelabs/sl-module-builds';

import * as types from './../types';
import { rdcBuildsV2Types } from './../rdc/types';
import { vdcBuildsV2Types } from './../vdc/types';
import { types as filterTypes } from './../../filters';

export const initialState = Map({
  rdcBuildsLoading: true,
  vdcBuildsLoading: true,
});

const commonReducer = (state = initialState, { type }) => {
  switch (type) {
    case rdcBuildsV2Types.BUILDS_GET.SUCCESS:
      return state.set('rdcBuildsLoading', false);
    case buildsTypes.BUILDS_GET.SUCCESS:
    case vdcBuildsV2Types.BUILDS_GET.SUCCESS:
      return state.set('vdcBuildsLoading', false);
    case rdcBuildsV2Types.BUILDS_GET.FAILURE:
      return state.set('rdcBuildsLoading', false);
    case buildsTypes.BUILDS_GET.FAILURE:
    case vdcBuildsV2Types.BUILDS_GET.FAILURE:
      return state.set('vdcBuildsLoading', false);
    case rdcBuildsV2Types.INITIALIZE:
      return state.set('rdcBuildsLoading', true);
    case vdcBuildsV2Types.INITIALIZE:
      return state.set('vdcBuildsLoading', true);
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
    case filterTypes.SELECT_OWNER:
    case filterTypes.TOGGLE_STATUS:
      return state.withMutations((newState) => {
        newState
          .set('rdcBuildsLoading', true)
          .set('vdcBuildsLoading', true);
      });
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default commonReducer;
